export const SET_BANNERS = 'SET_BANNERS'
export const ADD_BANNER = 'ADD_BANNER'
export const REMOVE_BANNER = 'REMOVE_BANNER'
export const UPDATE_BANNER = 'UPDATE_BANNER'
